import { testIf } from '../validationFunctions';
import { cleanArray } from '../../mergeFunctions';
import { successState, formatResults } from '../validationHelpers';

export const validateChestForm = ({ data, setNotificationText }) => {
  const testResults = cleanArray(testIf('empty')(data, ['chestName', 'firstTeam']));
  if (testResults.length === 0) return successState(setNotificationText);
  setNotificationText(formatResults(testResults));
};
